/**
 * example
 */

import Page from '~/page/page';
import Slider from '~/slider/slider';

export default class Example extends Slider {
  init() {
    const elements = {
      slider: '.js-example-slides',
      prev: '.js-example-prev',
      next: '.js-example-next'
    };

    this.set(elements);
  }
}

Page.mount(Example, '.js-example');
